import { createSlice } from "@reduxjs/toolkit";
import {
    getAllParams,
    getVoucheriData,
    sendAllParams
} from "../../api/Params";

export const paramsSlice = createSlice({
  name: "prms",
  initialState: {
    parametres: [],
    listpromos: []
  },
  reducers: {
    setParameters: (state, action) => {
      state.parametres = action.payload;
    },

    setListPromos: (state, action) => {
        state.listpromos = action.payload;
      },

    setParameter: (state, action) => {
      state.parametres.push(action.payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
    setParameters,
    setParameter,
    setListPromos
} = paramsSlice.actions;

export const getAllParameters = (user) => async (dispatch) => {
  try {
    const response = await getAllParams({ userId: user});
    if (!response.error && response.status === 200) {
      dispatch(setParameters(response.data.params));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const getVoucheriPromo = (user) => async (dispatch) => {
    try {
    const response = await getVoucheriData({ userId: user});
    if (!response.error && response.status === 200) {
      dispatch(setListPromos(response.data.promos));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
}

export const sendParameters = (user, values) => async (dispatch) => {
    try {
        const response = await sendAllParams({ userId: user, params: values});
        if (!response.error && response.status === 200) {
          dispatch(setParameters(response.data.params));
          return {
            status: "success",
          };
        }
        return {
          status: "error",
          type: "unkown",
        };
      } catch (e) {
        return {
          status: "error",
          type: "unknown",
        };
      }
}

export const selectListParams = (state) => state.prms.parametres;
export const selectListPromosBin = (state) => state.prms.listpromos;
export default paramsSlice.reducer;
